import {AbstractView} from "../../../views/AbstractView";
import {
  IEntitySelectionDropdownController,
  IT_ENTITY_SELECTION_DROPDOWN_CONTROLLER, MK_ENTITY_SELECTION_DROPDOWN
} from "../_controllers/IEntitySelectionDropdownController";
import {Component, effect, input, model, OnInit, output, untracked} from "@angular/core";
import {EntitySelectionDropdownConfig} from "../../../interfaces/domain/EntitySelectionDropdownConfig";
import {EntitySelectionDropdownModel} from "../_models/EntitySelectionDropdownModel";
import {EntitySelectionDropdownController} from "../_controllers/entity-selection-dropdown.controller";

@Component({
  selector: 'link-entity-selection-dropdown',
  templateUrl: './entity-selection-dropdown.view.html',
  styleUrls: ['./entity-selection-dropdown.view.scss'],
  providers: [
    { provide: IT_ENTITY_SELECTION_DROPDOWN_CONTROLLER, useClass: EntitySelectionDropdownController },
  ]
})
export class EntitySelectionDropdownView extends AbstractView<IEntitySelectionDropdownController> implements OnInit {

  readonly config = input.required<EntitySelectionDropdownConfig>();
  readonly selection = model<any>();
  readonly onSelectionChange = output<boolean>();
  readonly disabled = input(false);
  protected readonly model: EntitySelectionDropdownModel;

  constructor() {
    super(IT_ENTITY_SELECTION_DROPDOWN_CONTROLLER);

    this.model = this.getController().getModel(MK_ENTITY_SELECTION_DROPDOWN);

    effect(() => {
      const selectedItems = this.model.selectedItems$();

      untracked(() => {
        if(selectedItems !== this.selection()) {
          this.selection.set(selectedItems);
          this.onSelectionChange.emit(true);
        }
      });
    }, {allowSignalWrites: true});
  }

  ngOnInit() {
    this.getController().handle('InitialConfig', {
      initialConfig: this.config(),
    });

    this.getController().handle('InitialSelectedItems', {
      initialSelectedItems: this.selection(),
    });
  }

  scrollToEnd() {
    this.getController().handle('EndOfList', {});
  }

  search(event: any) {
    this.getController().handle('ItemSearch', {
      searchText: event['term'],
      matchedItems: event['items'],
    });
  }
}
